export enum OperationNatureEnum {
    UNKOWN = 'Unknown',
    RESEARCH_AND_DEVELOPMENT = 'Research and Development',
    PHOTOGRAPHY_FILMING_SURVEY = 'Photography, Filming, Survey',
    OBSERVATION_AND_VIGILANCE = 'Observation and Vigilance',
    EMERGENCY_SEARCH_AND_RESCUE = 'Emergency, Search and Rescue',
    PILOT_TRAINING = 'Pilot Training',
    AERIAL_PUBLICITY = 'Aerial Publicity',
    AERIAL_TREATMENTS = 'Aerial Treatments',
    RESEARCH = 'Research',
    PRODUCTION_TEST_MAINTENANCE = 'Production, Test and Maintenance',
    DEMONSTRATION = 'Demonstration',
    TEST_OR_VALIDATION = 'Test or Validation',
    R_AND_D = 'R&D',
    DEVELOPMENT = 'Development',
    ARTICLE_5 = 'Article 5',
    OTHER = 'Other',
}